export const environment = {
    production: false,
    apiUrl: 'https://colony-admin-dev.transnetyx.com/api',

    auth0: {
        domain: 'login-dev.transnetyx.com',
        clientId: 'KeGPSeswu02YfA57xarFMpHKhCD7TBw5',
        redirectUri: `${window.location.origin}`,
        logoutReturnUrl: `https://accounts-dev.transnetyx.com/v2/logout/colony`,
        logoutUrl: 'https://login-dev.transnetyx.com/v2/logout',
    },

    accountsUrl: 'https://accounts-dev.transnetyx.com/',
    geneticMonitoring: 'https://quickorder-dev.transnetyx.com/MVC/GeneticMonitoring',
    microbiome: 'https://quickorder-dev.transnetyx.com/MVC/Microbiome',
    supportHubUrl: 'https://www-dev.transnetyx.com/support',
    quickorder: 'https://quickorder-dev.transnetyx.com/home',

    colonyNotificationsUrl: 'https://colony-dev.transnetyx.com/Notifications',
    colonyOrdersCartUrl: 'https://colony-dev.transnetyx.com/Orders/Cart',
    colonyUrlDashboard: 'https://colony-dev.transnetyx.com',
    colonyUrlStrains: 'https://colony-dev.transnetyx.com/Strains',
    colonyUrlGeneMutations: 'https://colony-dev.transnetyx.com/Mutations',
    colonyUrlMice: 'https://colony-dev.transnetyx.com/Mice/MiceList',
    colonyUrlBreedings: 'https://colony-dev.transnetyx.com/Breedings',
    colonyUrlLitters: 'https://colony-dev.transnetyx.com/Litters',
    colonyUrlCages: 'https://colony-dev.transnetyx.com/Cage',
    colonyUrlCagesMapView: 'https://colony-dev.transnetyx.com/Cage/Cages',
    colonyUrlCagesList: 'https://colony-dev.transnetyx.com/Cage/CageList',
    colonyUrlCagesWorkbench: 'https://colony-dev.transnetyx.com/Cage/Workbench',
    colonyUrlTasks: 'https://colony-dev.transnetyx.com/Tasks',
    colonyUrlAmi: 'https://colony-dev.transnetyx.com/Ami/Projects',
    colonyUrlAmiCalculator: 'https://colony-dev.transnetyx.com/AmiCalculator',
    colonyUrlAdministrationUsers: 'https://colony-dev.transnetyx.com/Admin/User',
    colonyUrlAdministrationGroups: 'https://colony-dev.transnetyx.com/Admin/Group',
    colonyUrlAdministrationAuditLog: 'https://colony-dev.transnetyx.com/Admin/AuditLogSearch',
    colonyUrlAdministrationMouseImport: 'https://colony-dev.transnetyx.com/Mice/ImportAdmin',
    colonyUrlAdministrationReloadGroupData: 'https://colony-dev.transnetyx.com/Admin/Group/ResetGroups',
    colonyUrlAdministrationBannerMaintenance: 'https://colony-dev.transnetyx.com/Admin/Banner/Details',
    colonyUrlAdministrationScheduledJobs: 'https://colonyhangfiredev.azurewebsites.net/hangfire',
};
